import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import RoutesApp from './routes/Routes';
import { LangProvider } from './context/LangContext';
import { initGA, trackPageView } from './utils/analytics';

function App() {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <LangProvider>
      <RoutesApp />
    </LangProvider>
  );
}

export default App;
